'use strict';

/**
 * @fileoverview Funnel implementation for web sites
 *    {@see http://wiki.ostrovok.ru/wiki/Analytics/Funnel_v2}
 */

var hash = require('./hash');
var Transport = require('../transport');
var debug = require('../debug');
var events = require('../events');
var proxy = require('../proxy');
var cookies = require('../cookies')();
var prefixedCookies = require('../cookies')('_hcfnl_');
var ui = require('../ui');

var incognito = require('./incognito');
var trackAction = require('./trackaction');
var trackBlock = require('./trackblock');
var trackEvent = require('./trackevent');
var trackDisplays = require('./trackdisplays');
var syncCookies = require('./synccookies');

/**
 * @constructor
 */
var Funnel = function() {
  window.name = window.name || Math.round(Math.random() * 100000);
  this._hash = hash.guid();
  this._prev_hash = prefixedCookies.get('hash') || '';
  this._transport = new Transport('/funnel_v2');
  this._counter = 0;
  this._id = (+new Date()).toString(36) + '-' +
      (((1 + Math.random()) * 10000 * 0x10000) | 0).toString(36);
  this._funnelWasSent = false;
  this._preSendQueue = [];
  this._lastReq = null;
  this._data = {
    uidCookie: 'uid',
    funnelUidCookie: 'funnel_uid',
    platform: undefined,
    sitelang: undefined,
    navlang: navigator['language'] || navigator['systemLanguage'] ||
             navigator['browserLanguage'] || navigator['userLanguage'],
    noFlash: navigator.plugins['Shockwave Flash'] === undefined,
    windowName: window.name,
    initialUrl: null,
    has_adblk: null,
  };

  var actionListener = proxy(this.actionHandler, this);
  events.listen(window, 'mousedown', actionListener);
  events.listen(window, 'submit', actionListener);
  events.listen(window, 'contextmenu', actionListener);
  events.listen(window, 'touchstart', actionListener);

  this.block = trackBlock(this);
  this.event = trackEvent(this);
  this.displays = trackDisplays(this);

  this.setFunnelUid();

  this.checkAdblock();

  this._identified = false;
  syncCookies.periodically();
};

Funnel.prototype.setFunnelUid = function() {
  var funnelUid = prefixedCookies.get(this._data.funnelUidCookie) || hash.funnelUid(this._id);

  prefixedCookies.set(this._data.funnelUidCookie, funnelUid, 86400 * 365 * 5 * 1000);
};

Funnel.prototype.checkAdblock = function() {
  var el = document.createElement('script');
  el.src = ['/', CNT_HOST, DEPLOY_DIR, 'ads.js?check=true'].join('/');
  el.onload = proxy(function() {
    this._data.has_adblk = false;
  }, this);
  el.onerror = proxy(function() {
    this._data.has_adblk = true;
  }, this);

  document.head.appendChild(el);
};

Funnel.prototype.actionHandler = function() {
  prefixedCookies.set('hash', this._hash);
};

Funnel.prototype.send = function(opt_data, opt_post_data) {
  try {
    this.sendInternal(opt_data, opt_post_data);
  } catch(ex) {
    this.event('frontend', 'funnel', 'exception', {
      name: ex.name,
      stack: ex.stack
    },
    {},
    {
      force: true
    });
  }

  if (!this._identified) {
    syncCookies.identify();
    this._identified = true;
  }
};

Funnel.prototype.sendInternal = function(opt_data, opt_post_data) {
  var data = opt_data || {};

  var req = {};

  // change hash
  if (this._funnelWasSent === true) {
      this._prev_hash = this._hash;
      this._hash = hash.guid();
  }

  // required
  req.screen = ui.screenSize().join('x');
  req.pixel_ratio = ui.pixelRatio();
  req.viewport = ui.viewportSize().join('x');
  req.pagetype = data.pagetype;
  req.url = document.location.href;
  req.referer = document.referrer;
  req.js_prev_hit_id = this._prev_hash;
  req.js_hit_id = this._hash;
  req.platform = data.platform || this._data.platform;
  req.instance_id = this._id;
  req.is_incognito = incognito();
  req.no_flash = this._data.noFlash;
  req.has_adblk = data.has_adblk || this._data.has_adblk;

  // interface
  req.currency = data.currency || this._data.currency;
  req.navlang = this._data.navlang;
  req.sitelang = data.sitelang || this._data.sitelang;
  req.window_name = this._data.windowName;

  if (this._data.initialUrl) {
    req.initial_url = this._data.initialUrl;
  }

  // if user logged in, check special cookie
  req.is_auth = cookies.get('is_auth');

  // parent window
  try {
    req.is_window_top = window.self !== window.top;
  } catch (e) {
    req.is_window_top = true;
  }

  req.domain_uid = this.domainUid();

  // connection stats
  this.addConnectionStat(req, {
  // effective connection type determined using a combination of recently observed rtt and downlink values
    'connection_type':     'effectiveType',
  // effective bandwidth estimate
    'connection_downlink': 'downlink',
  // effective round-trip time estimate
    'connection_rtt':      'rtt'
  });

  for (var name in data) {
    req[name] = data[name];
  }

  req.hit_num = ++this._counter;

  debug.log('[funnel] send', req);

  this._lastReq = req;
  this._transport.send(req, opt_post_data);

  if (this._funnelWasSent === false) {
    this._funnelWasSent = true;
    this.sendPreSendQueue();
  }
};

Funnel.prototype.addConnectionStat = function(request, fields) {
  if (!navigator.connection) {
    return;
  }

  for (var field in fields) {
    if (fields.hasOwnProperty(field)) {
      var property = fields[field];

      if (navigator.connection[property]) {
        request[field] = navigator.connection[property];
      }
    }
  }
};

Funnel.prototype.wasSent = function() {
  return this._funnelWasSent;
};

Funnel.prototype.sendPreSendQueue = function() {
  var item;
  while (this._preSendQueue.length) {
    item = this._preSendQueue.shift();
    switch (item.type) {
      case 'action': this.action.apply(this, item.args); break;
      case 'block': this.block(item.display_type, item.action, item.display_id, item.unit, item.data); break;
      case 'event': this.event(item.category, item.action, item.opt_label, item.opt_data, item.opt_post_data, item.opt_options); break;
      case 'display': this.displays(item.opt_data); break;
    }
  };
  Transport.disableQueuedMode();
};

Funnel.prototype.action = function(intention, event, context) {
  if (this._funnelWasSent) {
    trackAction(this.domainUid(), this._hash,
        intention, event, context, this._lastReq, this._id);
  } else {
    this._preSendQueue.push({
      type: 'action',
      args: arguments
    });
  }
};

Funnel.prototype.url = function(urlPrefix) {
  Transport.setUrlPrefix(urlPrefix);
};

Funnel.prototype.hash = function(cb) {
  if (cb) {
    cb(this._hash);
  }
  return this._hash;
};

Funnel.prototype.instanceId = function() {
  return this._id;
};

Funnel.prototype.debug = function(enable) {
  debug.setEnabled(enable);
};

Funnel.prototype.verbose = function(enable) {
  this._transport.setVerbose(enable);
};

Funnel.prototype.platform = function(platform) {
  if (platform) {
    this._data.platform = platform;
  }
  return this._data.platform;
};

Funnel.prototype.counter = function() {
  return this._counter;
};

Funnel.prototype.addRelations = function(data) {
  data.domain_uid = this.domainUid();
  data.funnel_js_hit_id = this._hash;
  data.funnel_hit_num = this._counter;
  data.funnel_instance_id = this._id;
  data.pagetype = this._lastReq && this._lastReq.pagetype;
};

Funnel.prototype.isDebug = function() {
  return debug.isEnabled();
};

Funnel.prototype.domainUid = function() {
  this._data.uid = this._data.uid || cookies.get(this._data.uidCookie) || null;

  return this._data.uid;
};

Funnel.prototype.funnelUid = function() {
  this._data.funnel_uid = this._data.funnel_uid || prefixedCookies.get(this._data.funnelUidCookie) || null;

  return this._data.funnel_uid;
};

Funnel.prototype.decodeUid = function(uid) {
  function pad (hex) {
    while (hex.length < 8) {
      hex = '0' + hex;
    }

    return hex;
  }

  var binary = atob(uid),
      bytes  = new Uint8Array(16),
      parts  = new Uint32Array(bytes.buffer),
      result = '';

  for (var i = 0; i < bytes.byteLength; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  for (var i = 0; i < parts.length; i++) {
    result += pad(parts[i].toString(16));
  }

  return result.toUpperCase();
};

Funnel.prototype.hexDomainUid = function() {
  return this.decodeUid(this.domainUid());
};

Funnel.prototype.hexFunnelUid = function() {
  return this.decodeUid(this.funnelUid());
};

Funnel.PublicCommands = [
  'currency',
  'sitelang',
  'uid',
  'uidCookie',
  'initialUrl',
];

var setter = function(name) {
  return function(value) {
    this._data[name] = value;
  };
};

for (var i = 0, l = Funnel.PublicCommands.length; i < l; i++) {
  Funnel.prototype[Funnel.PublicCommands[i]] = setter(Funnel.PublicCommands[i]);
}

Funnel.PublicCommands.push('hash', 'send', 'event', 'displays', 'platform', 'action', 'url', 'debug', 'verbose', 'instanceId', 'block', 'wasSent', 'hexDomainUid', 'hexFunnelUid', 'decodeUid');

module.exports = Funnel;



//////////////////
// WEBPACK FOOTER
// ./lib/funnel/funnel.js
// module id = 3
// module chunks = 1 3